export enum SdLocaleSelectorA11yTemplates {
  default = 'default',
  menu = 'menu',
}
